import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs'
import { IReservation } from 'app/shared/models/reservation.interfaces';
import { AuthHttpService } from 'app/shared/auth-http.service';
import { EnvironmentService } from 'app/environment.service';

@Injectable()
export class ReservationService {

    constructor(private http: AuthHttpService, private enviromentService: EnvironmentService) {
    }

    public getReservation(reservationCode: string): Observable<IReservation> {
        return this.http.get<IReservation>(`${this.enviromentService.getSbServiceUrl()}/api/reservation/${reservationCode}`)
    }

    public getReservationNoCache(reservationCode: string): Observable<IReservation> {
        let headers = { 'Cache-Control': 'no-cache' }
        return this.http.get<IReservation>(`${this.enviromentService.getSbServiceUrl()}/api/reservation/${reservationCode}`, { headers })
    }
}
